import { RESTError } from "../core/RESTError";

/**
 * An error that occurs when an invalid access code is provided by the user to log in.
 */
export class InvalidAccessCodeError extends RESTError {}
